export default "__VITE_ASSET__BabplS0J__"